import { useContext } from 'react';
import * as React from 'react';

export const ActiveSessionsContext = React.createContext({});
export const ActiveSessionsProvider = ActiveSessionsContext.Provider;
export const ActiveSessionsConsumer = ActiveSessionsContext.Consumer;

ActiveSessionsContext.displayName = 'ActiveSessionsContext';

export const useActiveSessions = () => useContext(ActiveSessionsContext);